import React from 'react';




class Card extends React.Component {
    render() {
        return (
            <div>
                <div className="tab_bg">
                    <div className="container">
                        <div className="tab_list">
                            <ul>
                                <li className="active_tab">
                                    <a href="javascript:void(0)">Most Liked</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">Most Recent</a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)">show all post</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="card_bg">
                    <div className="container">
                        <div className="card_content">
                            <img src="/assets/img/img-1.jpg" className="img-fluid" alt="" />
                            <h4>Manish Vajpayee</h4>
                            <h5>Republic Day</h5>
                            <h6><img src="/assets/img/like.png" className="img-fluid img_like" alt="" /><span>1488</span></h6>
                        </div>

                        <div className="card_content">
                            <img src="/assets/img/img-2.jpg" className="img-fluid" alt="" />
                            <h4>Anshum Singhal</h4>
                            <h5>Holi</h5>
                            <h6><img src="/assets/img/like.png" className="img-fluid img_like" alt="" /><span>1341</span></h6>
                        </div>

                        <div className="card_content">
                            <img src="/assets/img/img-1.jpg" className="img-fluid" alt="" />
                            <h4>Manish Vajpayee</h4>
                            <h5>Republic Day</h5>
                            <h6><img src="/assets/img/like.png" className="img-fluid img_like" alt="" /><span>1488</span></h6>
                        </div>

                        <div className="card_content">
                            <img src="/assets/img/img-2.jpg" className="img-fluid" alt="" />
                            <h4>Anshum Singhal</h4>
                            <h5>Holi</h5>
                            <h6><img src="/assets/img/like.png" className="img-fluid img_like" alt="" /><span>1341</span></h6>
                        </div>
                    </div>
                </div>

            </div>

        )
    }
}

export default Card;